import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { ErrorMessage } from 'types';
import { client } from 'utils/api-client';

export default function useDeleteOtherWorkEvent(): UseMutationResult<
  AxiosResponse<null>,
  AxiosError<ErrorMessage>,
  string
> {
  const queryClient = useQueryClient();

  const deleteOtherWorkEvent = (otherWorkEventId: string): Promise<AxiosResponse<null>> => {
    return client.delete(`other-work-events/${otherWorkEventId}/`);
  };

  return useMutation(deleteOtherWorkEvent, {
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['payrollEvents'],
      });
      queryClient.removeQueries({
        queryKey: ['otherWorkEvents'],
      });
      queryClient.invalidateQueries({
        queryKey: ['payrollPeriods'],
      });
    },
  });
}
